import { Router } from '@angular/router';
import { Guide } from '../../structure/types/guide.class';

export function mapGuide(item: any): Guide {
    return {
        id: item.id,
        slug: item.slug ?? null,
        title: item.title,
        image: item.image ?? null,
        fields: item.fields ?? null,
        status: item.status ?? null,
        progress: typeof item.progress === 'number' ? item.progress : null,
        categories: item.categories ?? [],
        categoryTitle: item.categoryTitle ?? null,
        updatedAt: item.updated_at ?? item.updatedAt ?? null,
        startedAt: item.started_at ?? item.startedAt ?? null,
        lastActivityAt: item.last_activity_at ?? item.lastActivityAt ?? null,
    };
}

export function mapGuidesResponse(response: any): Guide[] {
    const body = response?.data ?? response;
    const list = Array.isArray(body?.data) ? body.data : (Array.isArray(body) ? body : []);
    return (list as any[]).map(item => mapGuide(item));
}

export function resolveCategoryLabel(category: any): string {
    const value = category?.name ?? category?.title ?? '';
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') {
        const first = Object.values(value)[0] as string | undefined;
        return first ?? '';
    }
    return '';
}

export function mapCategoryOptions(response: any): Array<{ id: number; label: string; slug: string }> {
    const body = response?.data ?? response;
    const list = Array.isArray(body?.data) ? body.data : (Array.isArray(body) ? body : []);
    return (list as any[]).map(category => ({
        id: category.id,
        label: resolveCategoryLabel(category),
        slug: category.slug,
    })).sort((a, b) => a.label.localeCompare(b.label));
}

export function recencyValue(guide: Guide): number {
    const dateValue =
        guide.lastActivityAt ||
        guide.updatedAt ||
        guide.startedAt ||
        null;
    const timestamp = dateValue ? Date.parse(dateValue) : NaN;
    if (!Number.isNaN(timestamp)) return timestamp;
    return (guide.id ?? 0) * 1000;
}

export async function navigateToGuide(router: Router, guide: Guide): Promise<void> {
    const isNotStarted = !guide.status || guide.status === 'not_started';

    if (isNotStarted) {
        await router.navigate(['/guide', guide.id, 'preview']);
        return;
    }

    const commands = ['/guide', guide.id];
    const queryParams = guide.status === 'completed' ? { retake: 1 } : {};
    await router.navigate(commands, { queryParams });
}
